export default "__VITE_ASSET__DLoc_lrf__"